/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Filter_IssuedInputs */

const vi_einvoice_filter_issued = /** @type {(inputs: Einvoice_Filter_IssuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã hoàn tất đối soát trong ERP`)
};

/**

* @param {Einvoice_Filter_IssuedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_filter_issued = /** @type {((inputs?: Einvoice_Filter_IssuedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Filter_IssuedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_filter_issued(inputs)
});